import React from 'react';
import * as _ from 'lodash';
import {Overlay, Tooltip} from 'react-bootstrap';
import {CompareBucketList} from './../containers/CompareBucketList';
import {disableCompareBucketBackground, enableCompareBucketBackground, disableScroll, enableScroll} from './../utils';
import './CompareBucket.scss';

export default class CompareBucket extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            showAddFlag: false
        };
        this.toggleCompareBucket = this.toggleCompareBucket.bind(this);
        this.openCompareBucket = this.openCompareBucket.bind(this);
        this.closeCompareBucket = this.closeCompareBucket.bind(this);
        this.handleDocumentTouch = this.handleDocumentTouch.bind(this);
        this.handleAddCurrent = this.handleAddCurrent.bind(this);
    }

    toggleCompareBucket() {
        this.state.isOpen ? this.closeCompareBucket() : this.openCompareBucket();
    }

    openCompareBucket() {
        this.setState({isOpen: true});
        disableScroll();
        enableCompareBucketBackground();
    }

    closeCompareBucket() {
        this.setState({isOpen: false});
        enableScroll();
        disableCompareBucketBackground();
    }

    handleAddCurrent() {
        this.props.addModelToCompareBucket(this.props.currentModel);

        this.setState({
            showAddFlag: true
        });

        let addedTimeout = setTimeout(() => {
            this.setState({
                showAddFlag: false
            });
            clearTimeout(addedTimeout);
        }, 1500)
    }

    handleDocumentTouch(e) {
        if (!this.bucketContainer.contains(e.target) && this.state.isOpen) {
            this.closeCompareBucket();
        }
    };

    componentWillMount() {
        document.addEventListener('touchstart', this.handleDocumentTouch);
    }

    componentWillUnmount() {
        document.removeEventListener('touchstart', this.handleDocumentTouch);
    }

    render() {
        const {isOpen} = this.state;
        const {MAX_SIZE, id, currentModel, bucket} = this.props;
        let counterClass = 'compare-bucket__counter';

        if(this.state.showAddFlag) {
            counterClass += ' compare-bucket__counter--added';
        } else if(!bucket.length) {
            counterClass += ' compare-bucket__counter--add';
        }

        return (
            <div
                ref={(element) => {this.bucketContainer = element}}
                id={id}
                className="compare-bucket__container"
            >
                <div className="compare-bucket__buttons">
                    <button
                        className={counterClass}
                        onClick={this.toggleCompareBucket}
                        ref={element => {
                            this.toggler = element
                        }}
                    >
                        {
                            bucket.length > 0 && !this.state.showAddFlag &&
                            <span className="compare-bucket__counter__value">
                                {bucket.length}
                            </span>
                        }
                    </button>
                    {
                        bucket.length < MAX_SIZE && !_.find(bucket, {id: currentModel.id}) && !this.state.showAddFlag ?
                            <button
                                className="crux-label-style compare-bucket__label compare-bucket__button--add"
                                onClick={this.handleAddCurrent}
                            >
                               add to compare
                           </button>
                        : this.state.showAddFlag ?
                            <button
                                className="crux-label-style compare-bucket__label compare-bucket__button--added"
                            >
                                added!
                            </button>
                        :
                            <button
                                className="crux-label-style compare-bucket__label"
                                onClick={this.openCompareBucket}
                            >
                                view compare
                            </button>
                    }
                    <Overlay
                        show={isOpen}
                        onHide={this.closeCompareBucket}
                        container={this}
                        rootClose={true}
                        target={this.toggler}
                        placement="bottom"
                    >
                        <Tooltip
                            id={`${id}-tooltip`}
                            className="compare-bucket__tooltip"
                        >
                            <div className="hidden-lg hidden-md hidden-sm compare-bucket-mobile-nav">
                                <p className="crux-call-to-action">Compare</p>
                                <span className="crux-body-copy crux-body-copy--extra-small">
                                    <button onClick={this.closeCompareBucket}>
                                        <span className="crux-label-style crux-label-style--small">Close</span>
                                        <span className="crux-icons crux-icons-close"/>
                                    </button>
                                </span>
                            </div>
                            <CompareBucketList/>
                        </Tooltip>
                    </Overlay>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/CompareBucketRedux/components/CompareBucket.jsx